const ko = {
  meta: {
    home: { title: "제니퍼 로페즈 전기와 타임라인 | 독립 JLo 트리뷰트", description: "독립적인 다국어 타임라인을 통해 제니퍼 로페즈의 삶, 경력, 음악, 영화, 스타일, 문화적 영향을 살펴보세요. 공식 웹사이트가 아닙니다." },
    timeline: { title: "제니퍼 로페즈 타임라인 | 독립 JLo 트리뷰트", description: "제니퍼 로페즈의 경력과 문화적 영향을 출처와 함께 정리한 연대기. 독립 트리뷰트 — 공식 웹사이트가 아닙니다." },
    music: { title: "제니퍼 로페즈 음악과 앨범 | 독립 JLo 트리뷰트", description: "제니퍼 로페즈 음악 경력의 주요 순간 선별. 독립 트리뷰트 — 공식 웹사이트가 아닙니다." },
    film: { title: "제니퍼 로페즈의 영화 | 독립 JLo 트리뷰트", description: "제니퍼 로페즈 영화 경력의 주요 순간 선별. 독립 트리뷰트 — 공식 웹사이트가 아닙니다." },
    style: { title: "제니퍼 로페즈 스타일과 패션 | 독립 JLo 트리뷰트", description: "패션과 레드카펫에서의 제니퍼 로페즈의 영향. 독립 트리뷰트 — 공식 웹사이트가 아닙니다." },
    legacy: { title: "제니퍼 로페즈 문화적 영향과 유산 | 독립 JLo 트리뷰트", description: "제니퍼 로페즈가 세대를 대표하는 아티스트인 이유. 독립 트리뷰트 — 공식 웹사이트가 아닙니다." },
    about: { title: "이 프로젝트에 대하여 | 독립 JLo 트리뷰트", description: "제니퍼 로페즈에 대한 이 독립적이고 다국어인 트리뷰트와 타임라인에 대하여. 공식 웹사이트가 아닙니다." },
    disclaimer: { title: "면책 조항 | 독립 JLo 트리뷰트", description: "독립 트리뷰트 웹사이트 면책 조항. 제니퍼 로페즈와 제휴하거나 승인받지 않았습니다. 공식 웹사이트가 아닙니다." },
    contact: { title: "문의하기 | 독립 JLo 트리뷰트", description: "이 제니퍼 로페즈 트리뷰트를 운영하는 독립 팀에 문의하세요. 공식 웹사이트가 아닙니다." },
    privacy: { title: "개인정보 처리방침 | 독립 JLo 트리뷰트", description: "이 독립 제니퍼 로페즈 트리뷰트 웹사이트의 개인정보 처리방침. 공식 웹사이트가 아닙니다." },
  },
  ui: {
    skipToContent: "본문으로 건너뛰기",
    exploreTimeline: "타임라인 보기",
    officialWebsite: "공식 웹사이트",
    officialStore: "공식 스토어",
    onTheJlo: "On The JLo",
    readMore: "더 보기",
    readLess: "접기",
    opensNewTab: "(새 탭에서 열립니다)",
    backToTop: "맨 위로",
    selectLanguage: "언어 선택",
    language: "언어",
    source: "출처",
    nav: { home: "홈", timeline: "타임라인", music: "음악", film: "영화", style: "스타일", legacy: "유산", about: "소개", disclaimer: "면책 조항", contact: "문의", privacy: "개인정보" },
  },
  disclaimer: {
    bar: "독립 트리뷰트 웹사이트 — 제니퍼 로페즈 또는 공식 팀과 제휴하거나 승인받지 않았습니다.",
    long: "이 사이트는 독립적인 트리뷰트·정보 웹사이트입니다. 제니퍼 로페즈, 그의 매니지먼트, 음반사, 브랜드, 공식 웹사이트 또는 공식 스토어와 제휴, 승인, 후원되거나 공식적으로 연결되어 있지 않습니다.",
  },
  hero: { title: "제니퍼 로페즈:", titleAccent: "브롱크스에서 글로벌 아이콘으로", subtitle: "제니퍼 로페즈의 삶, 예술성, 경력의 이정표, 문화적 영향을 탐구하는 독립적인 다국어 트리뷰트." },
  trust: { heading: "독립 트리뷰트", body: "이 사이트는 독립적인 트리뷰트·정보 웹사이트입니다. 제니퍼 로페즈, 매니지먼트, 레이블, 브랜드, 공식 웹사이트 또는 공식 스토어와 제휴, 승인, 후원되지 않습니다. 공식 정보는 아래 공식 링크를 이용하세요." },
  timelineSection: { kicker: "브롱크스에서 세계로", heading: "삶과 경력 타임라인", subtitle: "글로벌 경력을 형성한 순간들을 따라가는, 출처가 있는 연대기적 여정." },
  categories: { earlyLife: "초기 생애", music: "음악", film: "영화", dance: "댄스", fashion: "패션", business: "비즈니스", legacy: "유산" },
  pillarsSection: { kicker: "경력의 기둥", heading: "글로벌 경력의 여섯 기둥", subtitle: "그의 작업이 자취를 남긴 창의적·문화적 영역." },
  pillars: {
    music: { title: "음악", body: "댄스팝 데뷔부터 차트 1위 앨범까지, 음악은 20여 년간 그의 작업의 중심이었습니다." },
    film: { title: "영화", body: "로맨틱 코미디와 드라마, 『Hustlers』 같은 호평받은 연기까지 아우르는 탄탄한 영화 경력." },
    dance: { title: "댄스", body: "먼저 댄서로 훈련받았고, 움직임과 안무는 지금도 라이브 공연의 핵심입니다." },
    fashion: { title: "패션과 스타일", body: "레드카펫과 무대에서의 스타일은 패션과 미에 관한 폭넓은 논의에 영향을 주었습니다." },
    business: { title: "비즈니스와 브랜드", body: "향수와 라이프스타일 사업으로 확장하며 셀러브리티 브랜드 모델 형성에 기여했습니다." },
    impact: { title: "문화적 영향", body: "가장 주목받는 라틴계 아티스트 중 한 명으로서 주류 팝 문화에서 대표성을 넓혔습니다." },
  },
  impactSection: {
    kicker: "글로벌 영향",
    heading: "전 세계적인 문화적 발자취",
    subtitle: "일반적인 문화적 개관 — 과장된 수치는 의도적으로 피했습니다.",
    points: [
      { title: "라틴 팝 문화", body: "라틴 팝의 사운드와 아티스트를 세계 주류로 더 끌어올리는 데 기여했습니다." },
      { title: "할리우드에서의 대표성", body: "주연급 영화에서 라틴계 배우의 가시성을 높였습니다." },
      { title: "글로벌 음악 차트", body: "여러 앨범에 걸쳐 국제적인 차트 성공을 거두었습니다." },
      { title: "패션과 미", body: "레드카펫과 미용에서 널리 회자된 트렌드에 영향을 주었습니다." },
      { title: "라이브 공연", body: "대형 무대에서 에너지 넘치고 댄스 중심의 라이브로 잘 알려져 있습니다." },
      { title: "다문화 팬층", body: "여러 나라에 걸쳐 폭넓고 다국어인 팬층을 구축했습니다." },
    ],
  },
  worksSection: { kicker: "선별 작품", heading: "음악과 영화 하이라이트", music: "음악 하이라이트", film: "영화 하이라이트", whyItMatters: "왜 중요한가" },
  essay: {
    kicker: "에디토리얼",
    heading: "제니퍼 로페즈가 세대를 대표하는 아티스트 중 한 명이 된 이유",
    paragraphs: [
      "음악, 영화, 댄스 사이를 제니퍼 로페즈만큼 유연하게 오간 공연자는 드뭅니다. 뉴욕에서 댄서로 출발해, 하나의 분야에 머무르기를 거부한 경력을 쌓았습니다.",
      "『Selena』로의 도약과 곧이은 데뷔 앨범은 영화와 음악의 화제를 동시에 이끄는 드문 역량을 보여주었습니다. 이 다재다능함이 그의 상징이 되었습니다.",
      "작업 자체를 넘어 그의 가시성도 중요했습니다. 당대 가장 두드러진 라틴계 아티스트 중 한 명으로서 대표성을 넓혔고, 주류 팝 문화의 소리와 모습, 무대를 형성하는 데 기여했습니다.",
    ],
    pullQuote: "브롱크스에서 세계 무대로 — 다재다능함, 규율, 재창조 위에 세운 경력.",
  },
  faqSection: { kicker: "질문", heading: "자주 묻는 질문" },
  faq: {
    official: { q: "이곳이 제니퍼 로페즈의 공식 웹사이트인가요?", a: "아니요. 이 사이트는 독립적인 트리뷰트·정보 웹사이트입니다. 제니퍼 로페즈나 그의 팀과 제휴하지 않았습니다." },
    "where-website": { q: "제니퍼 로페즈의 공식 웹사이트는 어디인가요?", a: "‘공식 웹사이트’ 버튼을 사용해 공식 사이트를 방문하세요." },
    "where-store": { q: "공식 제니퍼 로페즈 상품은 어디서 사나요?", a: "‘공식 스토어’ 버튼을 사용하세요. 이 사이트에서는 어떤 상품도 판매하지 않습니다." },
    affiliated: { q: "이 웹사이트는 제니퍼 로페즈와 제휴되어 있나요?", a: "아니요. 어떤 형태의 제휴, 후원, 승인도 없습니다." },
    about: { q: "이 웹사이트는 무엇에 관한 것인가요?", a: "출처를 인용하여 제니퍼 로페즈의 경력과 문화적 영향을 다국어 타임라인과 소개로 제시합니다." },
  },
  officialSection: {
    heading: "제니퍼 로페즈 공식 링크",
    subtitle: "공식 정보를 찾으시나요? 이 외부 링크를 이용하세요.",
    websiteDesc: "제니퍼 로페즈의 공식 웹사이트.",
    storeDesc: "상품 공식 스토어.",
    onthejloDesc: "On The JLo의 공식 팬 업데이트.",
    note: "공식 링크는 새 탭에서 열립니다. 이 링크 대상과 제휴하지 않습니다.",
  },
  footer: {
    tagline: "제니퍼 로페즈의 삶, 경력, 문화적 영향에 바치는 독립적인 다국어 트리뷰트.",
    notOfficial: "비공식 · 비제휴 · 비승인. 상품 판매 없음.",
    explore: "둘러보기",
    official: "공식 링크",
    legal: "정보",
    copyright: "독립 트리뷰트 웹사이트. 모든 상표와 이름은 각 소유자에게 있습니다.",
  },
  pages: {
    timeline: { intro: "음악, 영화, 댄스, 문화의 주요 순간을 출처와 함께 정리한 연대기로, 브롱크스에서 글로벌 인지도로 향한 제니퍼 로페즈의 여정을 따라가 보세요." },
    music: { intro: "데뷔부터 최근 발매까지 제니퍼 로페즈의 음악 경력과 선별한 앨범 하이라이트 개관." },
    film: { intro: "『Selena』의 도약부터 최근 주연까지, 제니퍼 로페즈의 영화 경력에서 선별한 하이라이트." },
    style: { intro: "레드카펫과 무대에서의 제니퍼 로페즈의 존재가 패션과 미에 관한 폭넓은 논의와 어떻게 만났는지." },
    legacy: { intro: "제니퍼 로페즈의 문화적 영향과 그가 세대를 대표하는 아티스트로 여겨지는 이유를 다루는 에디토리얼." },
    about: {
      heading: "이 프로젝트에 대하여",
      paragraphs: [
        "이 프로젝트는 독립적인 트리뷰트이자 문화 아카이브입니다. 제니퍼 로페즈의 경력, 업적, 문화적 영향을 명확하고 다국어인 형식으로 제시하는 것을 목표로 합니다.",
        "공식 웹사이트가 아니며 제니퍼 로페즈, 매니지먼트, 레이블, 브랜드와 어떤 관계도 없습니다. 공식 업데이트는 사이트의 공식 링크를 이용하세요.",
        "콘텐츠는 공개된 신뢰할 수 있는 출처에 기반하며 정보 및 교육 목적으로 제공됩니다. 권리 보유자로서 수정을 원하시면 문의해 주세요.",
      ],
    },
    disclaimer: {
      heading: "면책 조항",
      intro: "이 면책 조항을 주의 깊게 읽어 주세요.",
      points: [
        "이곳은 제니퍼 로페즈의 공식 웹사이트가 아닙니다.",
        "제니퍼 로페즈나 그의 팀과 제휴, 승인, 후원되지 않았습니다.",
        "이 사이트에서는 상품, 티켓, 굿즈를 판매하지 않습니다.",
        "어떤 개인이나 단체를 사칭할 의도가 없습니다.",
        "모든 상표, 이름 및 관련 권리는 각 소유자에게 있습니다.",
        "공식 링크는 오직 방문자의 편의를 위해 제공됩니다.",
        "권리 보유자로서 콘텐츠의 수정, 출처 표기, 삭제를 원하시면 문의해 주세요.",
      ],
    },
    contact: {
      heading: "문의하기",
      intro: "이 트리뷰트 프로젝트를 운영하는 독립 팀에 연락하려면 아래 양식을 사용하세요.",
      rightsHolderNote: "제니퍼 로페즈, 그의 매니지먼트 또는 권리 보유자를 대표하며 콘텐츠의 수정, 업데이트, 출처 표기, 삭제 또는 리디렉션을 원하시면 문의해 주세요.",
      form: { name: "이름", email: "이메일", reason: "사유", message: "메시지", submit: "메시지 보내기", sending: "전송 중…", success: "감사합니다. 메시지가 접수되었습니다.", error: "문제가 발생했습니다. 다시 시도해 주세요." },
      reasons: { correction_request: "정정 요청", translation_issue: "번역 문제", copyright_trademark_concern: "저작권 / 상표 관련 우려", general_feedback: "일반 피드백" },
    },
    privacy: {
      heading: "개인정보 처리방침",
      paragraphs: [
        "이 독립 트리뷰트 웹사이트는 귀하의 개인정보를 존중합니다. 문의 양식으로 제출한 내용 등 귀하가 제공하기로 선택한 정보만 수집합니다.",
        "분석이 활성화된 경우 사이트 이용 방식을 파악하기 위해 익명의 이용 데이터가 수집될 수 있습니다. 운영자가 키를 설정하기 전까지는 어떤 분석도 실행되지 않습니다.",
        "문의 양식 데이터는 귀하의 메시지에 답하기 위해서만 사용되며 마케팅 목적으로 판매·공유되지 않습니다.",
        "이 사이트를 이용함으로써 본 방침에 동의하게 됩니다. 문의는 연락 페이지를 이용하세요.",
      ],
    },
    notFound: { heading: "페이지를 찾을 수 없습니다", body: "찾으시는 페이지가 존재하지 않거나 이동되었습니다.", cta: "홈으로 돌아가기" },
  },
  timeline: {
    "birth-1969": { title: "브롱크스에서 출생", summary: "제니퍼 린 로페즈는 1969년 7월 24일 뉴욕 브롱크스에서 푸에르토리코계 부모 사이에서 태어났습니다.", details: "노동자 계층의 푸에르토리코계 가정에서 자라 어릴 때부터 음악과 춤을 접했습니다." },
    "bronx-1970s": { title: "뉴욕에서 성장", summary: "브롱크스에서 어린 시절을 보내며 아이 때부터 노래와 춤을 배웠습니다.", details: "뉴욕에서의 이른 공연 경험이 이후 경력을 규정한 규율을 형성했습니다." },
    "dance-1980s": { title: "댄서로서의 훈련", summary: "10대에 춤에 전념하여 지역 공연과 뮤직비디오에서 활동했습니다.", details: "춤을 진지하게 추구하며 백댄서와 무대 공연자로 일했습니다." },
    "living-color-1991": { title: "In Living Color ‘Fly Girl’", summary: "TV 쇼 『In Living Color』의 ‘Fly Girl’ 댄서로 전국적 주목을 받았습니다.", details: "이 역할은 그에게 첫 지속적 TV 노출과 엔터테인먼트로 가는 길을 열어주었습니다." },
    "acting-start-1995": { title: "초기 연기 역할", summary: "『Mi Familia』, 『Money Train』 등의 영화 출연으로 연기로 전향했습니다.", details: "이 초기 역할들이 할리우드의 떠오르는 존재로 그를 자리매김시켰습니다." },
    "selena-1997": { title: "『Selena』로의 도약", summary: "테하노 가수 셀레나 킨타니야를 연기해 폭넓은 호평을 받은 도약을 이뤘습니다.", details: "주연으로 당대 가장 두드러진 라틴계 배우 중 한 명이 되었습니다." },
    "out-of-sight-1998": { title: "Out of Sight", summary: "스티븐 소더버그의 호평받은 범죄 영화에서 조지 클루니와 공연했습니다.", details: "이 연기는 진지한 영화 배우로서의 평판을 강화했습니다." },
    "on-the-6-1999": { title: "데뷔 앨범 『On the 6』", summary: "데뷔 앨범 『On the 6』로 음악 경력을 시작했으며, 제목은 브롱크스 지하철 노선에서 따왔습니다.", details: "「If You Had My Love」 같은 싱글이 그를 팝·댄스 아티스트로 자리매김시켰습니다." },
    "jlo-album-2001": { title: "『J.Lo』와 글로벌 브랜드", summary: "앨범 『J.Lo』와 ‘J.Lo’ 페르소나가 다분야 글로벌 브랜드로의 부상을 알렸습니다.", details: "영화와 음악 차트 정상을 동시에 차지하는 것으로 알려졌습니다." },
    "wedding-planner-2001": { title: "The Wedding Planner", summary: "로맨틱 코미디 주연으로 이 장르의 인기 시대를 규정하는 데 기여했습니다.", details: "이 영화는 흥행을 이끄는 존재로서의 지위를 강화했습니다." },
    "this-is-me-then-2002": { title: "『This Is Me... Then』", summary: "히트곡 「Jenny from the Block」를 수록해 브롱크스 뿌리를 강조했습니다.", details: "가장 개인적이고 상징적인 앨범 중 하나가 되었습니다." },
    "maid-in-manhattan-2002": { title: "Maid in Manhattan", summary: "주류 영화 스타덤을 확고히 한 대형 로맨틱 코미디 성공작.", details: "이 역할은 그의 폭넓은 상업적 매력을 부각시켰습니다." },
    "brand-fragrance-2005": { title: "향수와 비즈니스", summary: "향수와 라이프스타일 브랜드로 확장하며 지속적인 사업 입지를 구축했습니다.", details: "그의 사업은 미용에서 셀러브리티 브랜드 모델을 개척하는 데 기여했습니다." },
    "american-idol-2011": { title: "American Idol 심사위원", summary: "심사위원으로 『American Idol』에 합류해 방대한 TV 시청자에게 다가갔습니다.", details: "이 역할은 미국 전역에서 주류 가시성을 넓혔습니다." },
    "aka-2014": { title: "앨범 『A.K.A.』", summary: "음악, 영화, 텔레비전의 균형을 이어가며 『A.K.A.』를 발표했습니다.", details: "이 앨범은 레코딩 아티스트로서의 지속적인 진화를 반영했습니다." },
    "hustlers-2019": { title: "『Hustlers』 호평", summary: "『Hustlers』에서의 역할은 연기 경력에서 가장 강력한 평가 일부를 받았습니다.", details: "이 연기는 널리 호평받았고 시상식 시즌 논의를 되살렸습니다." },
    "super-bowl-2020": { title: "슈퍼볼 하프타임", summary: "샤키라와 함께 슈퍼볼 LIV 하프타임 쇼를 공동 헤드라이너로 장식했습니다.", details: "이 공연은 전 세계 관객 앞에서 라틴 문화를 기렸습니다." },
    "marry-me-2022": { title: "『Marry Me』", summary: "뮤지컬 로맨틱 코미디 『Marry Me』에 주연하고 제작에도 참여했습니다.", details: "이 프로젝트는 그의 음악과 영화 작업을 하나의 작품으로 결합했습니다." },
    "this-is-me-now-2024": { title: "『This Is Me... Now』", summary: "2002년 앨범의 짝이 되는 『This Is Me... Now』를 영화적 요소와 함께 발표했습니다.", details: "이 프로젝트는 경력 초기의 주제를 다시 다뤘습니다." },
    "atlas-2024": { title: "『Atlas』", summary: "SF 영화 『Atlas』에 주연하고 제작에도 참여했습니다.", details: "이 역할은 주연 배우 겸 제작자로서의 작업을 이어갔습니다." },
  },
  discography: {
    "on-the-6": { title: "On the 6", why: "데뷔작이 그를 신뢰할 만한 팝·댄스 아티스트로 자리매김시켰습니다." },
    jlo: { title: "J.Lo", why: "다분야 글로벌 브랜드로의 부상을 확고히 했습니다." },
    "this-is-me-then": { title: "This Is Me... Then", why: "싱글 「Jenny from the Block」가 그의 스타덤을 브롱크스 뿌리와 연결했습니다." },
    love: { title: "Love?", why: "댄스 플로어 싱글에 힘입은 팝 복귀를 알렸습니다." },
    aka: { title: "A.K.A.", why: "레코딩 아티스트로서의 지속적 진화를 보여주었습니다." },
    "this-is-me-now": { title: "This Is Me... Now", why: "20년 후 발표된 성찰적인 짝 작품." },
  },
  filmography: {
    selena: { title: "Selena", why: "그를 주요 스크린 재능으로 알린 결정적 주연." },
    "out-of-sight": { title: "Out of Sight", why: "그의 드라마적 폭을 입증한 비평적 호평." },
    "the-wedding-planner": { title: "The Wedding Planner", why: "로맨틱 코미디의 인기 시대를 규정하는 데 기여." },
    "maid-in-manhattan": { title: "Maid in Manhattan", why: "주류 스타덤을 확고히 한 흥행작." },
    "monster-in-law": { title: "Monster-in-Law", why: "베테랑 공연자와 함께한 상업적 코미디 성공." },
    hustlers: { title: "Hustlers", why: "경력 최고의 연기 중 하나로 널리 평가됩니다." },
    "marry-me": { title: "Marry Me", why: "그의 음악과 영화 정체성을 융합했습니다." },
    "the-mother": { title: "The Mother", why: "대형 스트리밍 플랫폼에서의 주연 액션 역할." },
    atlas: { title: "Atlas", why: "제작 야망을 반영한 SF 주연." },
  },
};

export default ko;
